export default __webpack_public_path__ + "static/media/logo-myarchery.4d4af694.png";